import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import MartyrCard from '../components/MartyrCard';
import LoadingSpinner from '../components/LoadingSpinner';
import ErrorMessage from '../components/ErrorMessage';
import { martyrsApi } from '../services/api';

const MartyrsPage = () => {
  const [martyrs, setMartyrs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    const fetchMartyrs = async () => {
      try {
        setLoading(true);
        const data = await martyrsApi.getAll({ page: currentPage, limit: 9 });
        setMartyrs(data.martyrs || []);
        if (data.pagination) {
          setTotalPages(data.pagination.totalPages);
          setTotalItems(data.pagination.totalItems);
        }
      } catch (err) {
        setError(err.message || 'حدث خطأ أثناء تحميل بيانات الشهداء');
      } finally {
        setLoading(false);
      }
    };
    fetchMartyrs();
  }, [currentPage]);

  return (
    <Layout>
      <Seo title="الشهداء" description="بطاقات الشهداء: الصورة، الاسم، والنبذة." />
      <PageHero eyebrow="الأرشيف" title="الشهداء" subtitle="كل بطاقة وجهٌ وسيرة. اختر اسماً لتقرأ التفاصيل والمعرض وما كُتب عنه." />
      <div className="container-responsive py-12">
        <p className="mb-8 text-stone-500">{totalItems} سيرة موثّقة</p>
        {loading && <LoadingSpinner size="xl" text="جاري التحميل..." />}
        {error && <ErrorMessage error={error} onRetry={() => setCurrentPage(1)} />}
        {!loading && !error && (
          <div className="grid gap-6 md:grid-cols-2">
            {martyrs.map((martyr, index) => (
              <MartyrCard key={martyr.id} martyr={martyr} featured={index === 0 && currentPage === 1} />
            ))}
          </div>
        )}
        {totalPages > 1 && (
          <div className="mt-10 flex justify-center gap-2">
            <button className="btn btn-outline" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>السابق</button>
            <span className="px-4 py-2">{currentPage} / {totalPages}</span>
            <button className="btn btn-outline" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>التالي</button>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default MartyrsPage;
